import { Action, createReducer, on } from '@ngrx/store'

import { FolderScopesActions } from '../actions/folder-scopes.actions'
import { FolderScopesState } from '../models'
import { ScopeVersion } from '@app/core/model/scope-version'
import { folderScopesInitialState } from '../const'
import { plainToInstance } from 'class-transformer'

const loadingTableHandler = (state: FolderScopesState) => ({ ...state, isLoadingTable: true })

const getColumnsSuccessHandler = (state: FolderScopesState, { columns }) => ({
  ...state,
  isLoadingTable: false,
  columns,
})

const getScopeDetailsHandler = (state: FolderScopesState, { scope }) => ({
  ...state,
  scopeDetails: { ...state.scopeDetails, [scope.identity.id]: { isLoading: true, scope: null } },
})
const getScopeDetailsSuccessHandler = (state: FolderScopesState, { scope }) => ({
  ...state,
  scopeDetails: {
    ...state.scopeDetails,
    [scope.identity.id]: { isLoading: false, scope: plainToInstance(ScopeVersion, scope) },
  },
})
const getScopeDetailsFailHandler = (state: FolderScopesState, { id }) => ({
  ...state,
  scopeDetails: { ...state.scopeDetails, [id]: { isLoading: false, scope: null } },
})

const getDeliverableDetailsSuccessHandler = (state: FolderScopesState, { scopeId, deliverable }) => ({
  ...state,
  scopeDetails: {
    ...state.scopeDetails,
    [scopeId]: {
      ...state.scopeDetails[scopeId],
      scope: plainToInstance(ScopeVersion, {
        ...state.scopeDetails[scopeId].scope,
        deliverables: state.scopeDetails[scopeId].scope.deliverables.map((d) =>
          d.id === deliverable.id ? deliverable : d
        ),
      }),
    },
  },
})

const deleteScopeSuccessHandler = (state: FolderScopesState) => ({ ...state, isLoadingTable: false })

const FolderScopesReducer = createReducer(
  folderScopesInitialState,
  on(
    FolderScopesActions.getColumnPreference,
    FolderScopesActions.updateColumnPreference,
    FolderScopesActions.deleteScope,
    FolderScopesActions.removeScope,
    loadingTableHandler
  ),
  on(
    FolderScopesActions.getColumnPreferenceSuccess,
    FolderScopesActions.updateColumnPreferenceSuccess,
    getColumnsSuccessHandler
  ),
  on(FolderScopesActions.deleteScopeSuccess, FolderScopesActions.removeScopeSuccess, deleteScopeSuccessHandler),
  on(FolderScopesActions.getScopeDetails, getScopeDetailsHandler),
  on(FolderScopesActions.getScopeDetailsFail, getScopeDetailsFailHandler),
  on(FolderScopesActions.getScopeDetailsSuccess, getScopeDetailsSuccessHandler),
  on(FolderScopesActions.getDeliverableDetailsSuccess, getDeliverableDetailsSuccessHandler)
)

export function folderScopesReducer(state: FolderScopesState | undefined, action: Action): FolderScopesState {
  return FolderScopesReducer(state, action)
}
